<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header class="d-flex justify-content-between">
                <div>
                    <h4 class="font-weight-bold text-uppercase">
                        Form Tambah Baru
                    </h4>
                </div>
                <div>
                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="secondary" class="btn-icon"
                        :to="{ name: 'masterJenisRuangan' }">
                        <feather-icon icon="CornerUpLeftIcon" />
                    </b-button>
                </div>
            </b-card-header>
            <b-card-body>
                <div>
                    <validation-observer ref="simpleRules">
                        <div class="row">
                            <div class="col-12">
                                <div>
                                    <span class="required">Jenis Ruangan <span class="text-danger">*</span></span>
                                </div>
                                <validation-provider #default="{ errors }" name="Jenis Ruangan" rules="required">
                                    <b-form-input v-model="formDatas.jenis_ruangan"
                                        :state="errors.length > 0 ? false : null" placeholder="Isi Jenis Ruangan" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </div>
                        </div>
                    </validation-observer>
                    <b-row>
                        <b-col cols="12">
                            <div class="my-2">
                                <b-button variant="primary" @click="submitForm">
                                    Simpan
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
  
<script>

import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'

import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BCardText,
} from 'bootstrap-vue'
import { required } from '@validations'
import masterJenisRuangan from "@/composables/master/jenisRuangan";
import { id as localeId } from "vee-validate/dist/locale/id";
import { showNotifikasi } from '@/libs/helper';
export default {
    setup(props, context) {
        localize('id', localeId);
        const g = context.root;
        const formDatas = ref({});

        const submitForm = async () => {
            await context.refs.simpleRules.validate().then(async success => {
                if (success) {
                    masterJenisRuangan.submitAdd(g, formDatas.value).then(resp => {
                        if (resp.success) {
                            showNotifikasi(g, 'success', 'Success', resp.message)
                            g.$router.push({ name: 'masterJenisRuangan' })
                        } else {
                            showNotifikasi(g, 'danger', 'Error', resp.message)
                        }
                    })
                }
            });
        };
        return {
            formDatas,
            submitForm
        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        BCardText,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
    },
    data() {
        return {
            required,
        }
    },
    directives: {
        Ripple,
    },
    props: {
        page: String,
    },
};
</script>